export const getUniqueId = (radix: number = 16) => {
  return Math.random().toString(radix).slice(2);
};
